export const ENVIRONMENT = process.env.REACT_APP_ENVIROMENT || "staging";
